import { Component, OnInit } from '@angular/core';
import type { ColDef } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rules-execution-system',
  templateUrl: './rules-execution-system.component.html',
  styleUrl: './rules-execution-system.component.scss',
})
export class RulesExecutionSystemComponent implements OnInit {

  public constructor(
    private router: Router
  ) {}

  public ngOnInit() {}
    // Row Data: The data to be displayed.
    rowData = [
      { make: "Tesla", model: "Model Y", price: 64950, electric: true },
      { make: "Ford", model: "F-Series", price: 33850, electric: false },
      { make: "Toyota", model: "Corolla", price: 29600, electric: false },
  ];

  // Column Definitions: Defines the columns to be displayed.
  colDefs: ColDef[] = [
      { field: "make" },
      { field: "model" },
      { field: "price" },
      { field: "electric" }
  ];

  defaultColDef: ColDef = {
    flex: 1,
  };

  onGridReady(event: any) {
    console.log('Grid is ready', event);
}

onAddRule() {
  // TODO: Implement logic to open add rule modal or navigate as needed
  console.log('Add Rule button clicked');
}

isRulesTabActive(): boolean {
  // Checks if the current route is /rules or a child route of /rules (but not /rulesets or /reminder-sets)
  return this.router.url.startsWith('/rules') &&
    !this.router.url.startsWith('/rules/rulesets') &&
    !this.router.url.startsWith('/rules/reminder-sets');
}

showRulesBuilder: boolean = false;
}
